<!-------------Features Fold Start----------------->
<div data-aos="fade-up" id="features" class="app__features__fold">
    <div class="container">
      <h1 data-aos="fade-up">It's Fun and Easy to Use</h1>
      <div class="app__features__section">
        <div class="row">
          <div class="col-lg-5 col-md-5 col-sm-5">
            <div class="app_features_slider">
              <div class="app_features_slider_items">
                <div class="features_slider_text">
                  <i><img src="/assets/images/svg_icons/sign-up-icon.svg"></i>
                  <div class="features_slider_text_r">
                    <strong>Sign Up</strong>
                    <p>Duis varius lectus eget risus dapibus pharetra. Sed porttitor pulvinar blandit.</p>
                  </div>
                </div>

              </div>

              <div class="app_features_slider_items">
                <div class="features_slider_text">
                  <i><img src="/assets/images/svg_icons/search-store.svg"></i>
                  <div class="features_slider_text_r">
                    <strong>Easy way to search store</strong>
                    <p>Duis varius lectus eget risus dapibus pharetra. Sed porttitor pulvinar blandit.</p>
                  </div>
                </div>

              </div>

              <div class="app_features_slider_items">
                <div class="features_slider_text">
                  <i><img src="/assets/images/svg_icons/gift-icon.svg"></i>
                  <div class="features_slider_text_r">
                    <strong>Send Coupons as Gift</strong>
                    <p>Duis varius lectus eget risus dapibus pharetra. Sed porttitor pulvinar blandit.</p>
                  </div>
                </div>

              </div>

              <div class="app_features_slider_items">
                <div class="features_slider_text">
                  <i><img src="/assets/images/svg_icons/friends-icon.svg"></i>
                  <div class="features_slider_text_r">
                    <strong>Make Friends</strong>
                    <p>Duis varius lectus eget risus dapibus pharetra. Sed porttitor pulvinar blandit.</p>
                  </div>
                </div>

              </div>

            </div>
          </div>
          <div class="col-lg-7 col-md-7 col-sm-7">
            <div class="slider-nav">
              <carousel>
                <slide>
                  <div class="app__features__img">
                    <img src="/assets/images/app__features__img.jpg" width="100%" />
                  </div>
                </slide>
                <slide>
                  <div class="app__features__img">
                    <img src="/assets/images/app__features__img2.jpg" width="100%" />
                  </div>
                </slide>
                <slide>
                  <div class="app__features__img">
                    <img src="/assets/images/app__features__img.jpg" width="100%" />
                  </div>
                </slide>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!---------------Features Fold End----------------->